import React from 'react';

const dropdownOptions = {
	dropdownOptions: {},
	setDropdownOptions: () => undefined,
};

export const DropdownOptionsContext = React.createContext(dropdownOptions);
